module.exports = __webpack_public_path__ + "img/FeaturePic3.eb14cbdf.png";